import { GoalBreakpointOption, WebSignupQueryParam } from '@naturalcycles/shared'
import { languageContext } from '@src/context/language.context'
import { getSignupURL } from '@src/helpers/signupUrl'
import classNames from 'classnames'
import { ReactNode, useCallback, useContext } from 'react'
import styles from './QuizButton.module.scss'

export interface QuizButtonProps {
  text: string
  goalNumber: GoalBreakpointOption
  iconUrl?: string
  utmSourceWeb: string
  themeModifier?: QuizButtonThemeModifier
}

export function QuizButton({
  text,
  goalNumber,
  iconUrl,
  utmSourceWeb,
}: QuizButtonProps): ReactNode {
  const { locale } = useContext(languageContext)
  const signupHref = useCallback(
    (goal: GoalBreakpointOption) => {
      const url = getSignupURL(`${locale}/onboarding/privacy`)
      url.searchParams.set('utm_source_web', utmSourceWeb)
      url.searchParams.set(WebSignupQueryParam.fg, String(goal))
      return url.toString()
    },
    [locale],
  )
  return (
    <a
      key={text}
      href={signupHref(goalNumber)}
      className={classNames(styles.QuizButton, {
        [styles.QuizButton___simpleWhite]: QuizButtonThemeModifier.simpleWhite,
      })}
      target="_blank"
      rel="noreferrer"
    >
      <span className={styles.QuizButton__text}>{text}</span>
      {iconUrl && <img src={iconUrl} alt="" className={styles.QuizButton__icon} loading="lazy" />}
    </a>
  )
}

export enum QuizButtonThemeModifier {
  simpleWhite = 'simpleWhite',
}
